import { TgvSubprodukt } from './tgvSubprodukt';
import { TiergruppePositions } from './tiergruppe.model';

export const canAddPosition = (
  positions: TiergruppePositions,
  subprodukt: TgvSubprodukt,
): boolean => {
  if (subprodukt === TgvSubprodukt.THH_HUND) {
    return positions.thhHund === null;
  }
  if (subprodukt === TgvSubprodukt.THH_PFERD) {
    return positions.thhPferd === null;
  }
  return subprodukt === TgvSubprodukt.TKV_V2;
};
